import { createContext, useContext, useCallback, useRef } from 'react'
import { BaseService } from '../../services/BaseService'
import { calculateSessionTime } from '../../utils/calculateSessionTime'

const LoggingContext = createContext()

export const LoggingProvider = ({ children }) => {
  const lastLogRef = useRef({})
  const debounceTimer = useRef(null)

  const addLog = useCallback((id_user, id_modul, keterangan = 'info') => {
    const now = Date.now()

    // Anti duplikat
    if (lastLogRef.current.keterangan === keterangan && now - lastLogRef.current.time < 800) {
      return Promise.resolve(null)
    }

    lastLogRef.current = { keterangan, time: now }

    // Hapus timer sebelumnya biar gak spam
    if (debounceTimer.current) clearTimeout(debounceTimer.current)

    // Balikin Promise biar bisa di-`await`
    return new Promise((resolve, reject) => {
      debounceTimer.current = setTimeout(async () => {
        const { time_end: timeNow } = calculateSessionTime()

        try {
          const service = new BaseService('/m_log_psikotest')
          const res = await service.postUserLog({
            id_user,
            id_modul,
            keterangan,
            time: timeNow,
          })
          resolve(res.data)
        } catch (err) {
          console.error('Gagal kirim log:', err)
          reject(err)
        }
      }, 400)
    })
  }, [])

  return <LoggingContext.Provider value={{ addLog }}>{children}</LoggingContext.Provider>
}

export const useLogging = () => useContext(LoggingContext)
